import React, { useEffect, useState, Fragment } from 'react';
interface CountdownTimerProps {
  variant?: 'bar' | 'block' | 'inline';
  initialMinutes?: number;
}
export function CountdownTimer({
  variant = 'block',
  initialMinutes = 23 * 60 + 47
}: CountdownTimerProps) {
  const [seconds, setSeconds] = useState(() => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem('mp_countdown_end') : null;
    if (stored) {
      const remaining = Math.max(0, Math.floor((parseInt(stored) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    const end = Date.now() + initialMinutes * 60 * 1000;
    if (typeof window !== 'undefined') localStorage.setItem('mp_countdown_end', end.toString());
    return initialMinutes * 60;
  });
  useEffect(() => {
    if (seconds <= 0) return;
    const i = setInterval(() => setSeconds(s => Math.max(0, s - 1)), 1000);
    return () => clearInterval(i);
  }, [seconds]);
  const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const m = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0');
  const s = (seconds % 60).toString().padStart(2, '0');
  if (variant === 'bar') {
    return <span className="font-mono font-bold tracking-wider tabular-nums" data-id="element-10">
        {h}:{m}:{s}
      </span>;
  }
  if (variant === 'inline') {
    return <span className="inline-flex items-center gap-1 font-mono font-bold tabular-nums text-terracotta-600" data-id="element-11">
        {h}:{m}:{s}
      </span>;
  }
  return <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-12">
      {[{
      v: h,
      l: 'HORAS'
    }, {
      v: m,
      l: 'MIN'
    }, {
      v: s,
      l: 'SEG'
    }].map((u, i) => <Fragment key={u.l} data-id="element-13">
          <div className="bg-earth-900 text-white rounded-xl px-3 py-2 sm:px-4 sm:py-3 min-w-[60px] sm:min-w-[72px] text-center shadow-lg" data-id="element-14">
            <div className="text-2xl sm:text-3xl font-bold font-mono tabular-nums leading-none" data-id="element-15">
              {u.v}
            </div>
            <div className="text-[10px] sm:text-xs text-earth-400 mt-1 tracking-wider" data-id="element-16">
              {u.l}
            </div>
          </div>
          {i < 2 && <span className="text-earth-900 text-2xl font-bold" data-id="element-17">:</span>}
        </Fragment>)}
    </div>;
}